import queryString from "query-string";
import {
  RangeSelectFilter,
  SearchValueFilter,
  SingleValuesFilter,
  UiValue,
  PaginationFilter,
  KeyValue,
} from "../../interfaces";
import { apiFieldMappings, uiFieldMappings } from "../../refdata/FilterOptions";

export const encodeBrowserPathFromState = (appState: KeyValue) => {
  const params = {} as any;
  // Translate all relevant parts of state to URL
  apiFieldMappings.rangeSelect.forEach(
    (rangeSelectFilter: RangeSelectFilter) => {
      if (
        appState.filters[rangeSelectFilter.filterNameStart] &&
        appState.filters[rangeSelectFilter.filterNameEnd]
      ) {
        params[rangeSelectFilter.filterNameStart] =
          appState.filters[rangeSelectFilter.filterNameStart];
        params[rangeSelectFilter.filterNameEnd] =
          appState.filters[rangeSelectFilter.filterNameEnd];
        if (rangeSelectFilter.filterDateRadio) {
          params[rangeSelectFilter.filterDateRadio] =
            appState.filters[rangeSelectFilter.filterDateRadio];
        }
      }
      //if only one of the ranges is added, still encode the value
      else if (
        (appState.filters[rangeSelectFilter.filterNameStart] &&
          !appState.filters[rangeSelectFilter.filterNameEnd]) || (!appState.filters[rangeSelectFilter.filterNameStart] &&
            appState.filters[rangeSelectFilter.filterNameEnd])
      ) {
        params[rangeSelectFilter.filterNameStart] =
          appState.filters[rangeSelectFilter.filterNameStart];
        params[rangeSelectFilter.filterNameEnd] =
          appState.filters[rangeSelectFilter.filterNameEnd];
      }
    },
  );

  apiFieldMappings.singleValues.forEach(
    (singleValuesFilter: SingleValuesFilter) => {
      if (appState.filters[singleValuesFilter.filterName]) {
        params[singleValuesFilter.filterName] =
          appState.filters[singleValuesFilter.filterName];
      }
    },
  );

  apiFieldMappings.arrayValues.forEach(
    (arrayValuesFilter: SingleValuesFilter) => {
      if (appState.filters[arrayValuesFilter.filterName]) {
        params[arrayValuesFilter.filterName] =
          appState.filters[arrayValuesFilter.filterName].join(",");
      }
    },
  );

  if (appState.sort.sortField) {
    params.sortField = appState.sort.sortField;
  }

  if (appState.sort.sortOrder) {
    params.sortOrder = appState.sort.sortOrder;
  }

  apiFieldMappings.paginationState.forEach(
    (paginationFilterValue: PaginationFilter) => {
      if (appState.pagination[paginationFilterValue.filterName]) {
        params[paginationFilterValue.filterName] =
          appState.pagination[paginationFilterValue.filterName];
      }
    },
  );

  apiFieldMappings.multiSelect.forEach((f: any) => {
    if (appState.filters[f.filterName]) {
      // don't encode if equivalent to select-all
      params[f.filterName] = appState.filters[f.filterName].join(" OR ");
    }
  });

  apiFieldMappings.searchValues.forEach(
    (searchValueFilter: SearchValueFilter) => {
      if (appState.search[searchValueFilter.searchName]) {
        params[searchValueFilter.searchName] =
          appState.search[searchValueFilter.searchName];
      }
    },
  );

  uiFieldMappings.singleUiValue.forEach((uiValue: UiValue) => {
    const query = JSON.stringify(appState.ui[uiValue.uiName]);
    if (query) {
      params[uiValue.uiName] = appState.ui[uiValue.uiName];
    }
  });

  uiFieldMappings.multiUiValues.forEach((uiValue: UiValue) => {
    const queryMultiString = JSON.stringify(appState.ui[uiValue.uiName]);
    if (queryMultiString) {
      params[uiValue.uiName] = appState.ui[uiValue.uiName].join(",");
    }
  });

  if (appState.displayFields) {
    params.displayFields = appState.displayFields.join(",");
  }

  return `?${queryString.stringify(params)}`;
};
